<div class="content-block">
  <article class="article " style="margin-top:1rem">

    <div class="title-container">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>
      <div style="flex: 10;">
        <h2>Engineer Management</h2>
      </div>
      <div style="flex:1;justify-content: flex-end;display: flex;">
        <div class="add" (click)="add()" *ngIf="!readOnly">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </div>
      </div>
    </div>




    <form class="card-title form-column " style="width: 100%;padding: 0.5rem;margin-top: 0.5rem;" (submit)="rebind()">
      <div class="form-row borderless " style="padding:0px;margin:0px;">

      <div class="col-md-3">
        <label>Name</label>
        <input type="text" style="width: 100%;" name="name" [(ngModel)]="filter.name" />
      </div>
        <div class="col-md-3"></div>

        <div class="col-md-3 col-sm-6"></div>
         <div class="col-md-3 col-sm-6">
            <label></label>
          <div class="btn-container" style="justify-content: flex-end;min-height: 57px;">

            <button class="btn btn-secondary" style="margin-right:1rem" (click)="resetFilters()">Reset</button>
            <button class="btn btn-primary" style="margin-right:1.25rem" value="Refresh">Refresh</button>
          </div>
        </div>

      </div>

    </form>

    <app-loading-icon *ngIf="loading"></app-loading-icon>

    <div
      style="display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: space-between; align-items: flex-start; width: 100%;;">

      <div style="flex: 8; width: 100%;">
        <div class="header">
          <div
            style="display: flex; width: 100%; flex-direction: row; flex-wrap: nowrap; justify-content: space-between; align-items: center; ">
            <div class="card custom-card" style="border-color: #D9E5D6; margin-right: 0.5%; ">
              Licenses Used
              <br />
              <h3><b>{{activeUsers}}</b></h3>
            </div>

            <div class="card custom-card" style="border-color: #0E8AB0; margin-left: 0.5%; margin-right: 0.5%">
              Licenses Remaining
              <br />
              <h3><b>{{expiredUsers}}</b></h3>
            </div>


            <div class="card custom-card" style="border-color: #EDDEA4; margin-left: 0.5%; ">
              Total Licenses
              <br />
              <h3><b>{{licenseCount}}</b></h3>
            </div>


          </div>
        </div>
      </div>

    </div>
    <div class="form-column borderless" style="display: block;">

      <ngx-datatable [count]="page.totalElements" [offset]="page.pageNumber" [limit]="page.size" [headerHeight]="50"
        [footerHeight]="50" (page)='setPage($event)' (sort)="onSort($event)" class="material" [rows]="rows"
        [rowClass]="getRowClass" [columnMode]="'force'" [externalPaging]="true" [externalSorting]="true"
        [rowHeight]="'auto'">

        <ngx-datatable-column name="Firstname" prop="firstname">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Surname" prop="surname">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="Option" *ngIf="!readOnly">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <a [routerLink]="['/engineers/manage', row.id]">Edit</a>
          </ng-template>
        </ngx-datatable-column>

      </ngx-datatable>
    </div>
  </article>
</div>